import React, { useContext, useEffect, useState } from 'react';
import MountainSearch from '../components/mountain-search.component';
import { Trans, useTranslation } from 'react-i18next';
import AppContext from '../data/AppContext';
import ClaimEntryComponent from '../components/claim-entry.component';
import baseTheme from '../baseTheme';
import {
  SlButton,
  SlButtonGroup,
  SlIcon,
} from '@shoelace-style/shoelace/dist/react';
// import Countup from '../components/countup';
import Countdown from '../components/countdown';
import { CHALLENGE_CONFIG } from '../challenge';
import SocialShare from '../components/share';

const Home = () => {
  // const { claimedMountainIds } = useContext(AppContext);
  const { t } = useTranslation('app');
  const { voices } = useContext(AppContext);

  const pageSize = 5;

  const [pagesAll, setPagesAll] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPagesAll(Math.ceil(voices.length / pageSize));
  }, [voices]);

  const pagePlus = () => {
    if (page < pagesAll) {
      setPage(page + 1);
    }
  };

  const pageMinus = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };

  return (
    <div>
      {window.innerWidth < 700 && (
        <h1 style={{ textAlign: 'center' }}>
          <div>{t('header.title')}</div>
          <small style={{ fontWeight: 'normal' }}>
            {t('header.challenge')}
          </small>
        </h1>
      )}

      <a
        href={t('home.learnMoreLink')}
        style={{
          margin: '0 0 1rem',
          display: 'block',
          textAlign: 'center',
          color: baseTheme.neutrals['700'],
        }}
      >
        {t('home.learnMore')}
      </a>

      <div>
          <Countdown
            goal={CHALLENGE_CONFIG.goalMountains}
            startDate={CHALLENGE_CONFIG.startDate}
            endDate={CHALLENGE_CONFIG.endDate}
          />
        <MountainSearch />
      </div>

      <section>
        <h2 style={{ margin: '2rem 0 1rem' }}>{t('social.title')}</h2>
        <SocialShare url={t('header.campaignLink')} title={t('social.description')} />
      </section>

      {!!voices.length && (
        <section>
          <h2 style={{ margin: '2rem 0 0.25rem' }}>
            {t('mountain.newestVoice')}
          </h2>
          <p style={{ margin: '0 0 1rem', color: baseTheme.neutrals['700'] }}>
            {t('home.newestVoicesDesc')}
          </p>
          {voices
            .slice(pageSize * (page - 1), pageSize * page)
            .map((entry, id) => (
              <ClaimEntryComponent claim={entry} key={id} />
            ))}

          {pagesAll > 1 && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginTop: '1rem',
              }}
            >
              <div
                style={{
                  color: baseTheme.neutrals['700'],
                  marginRight: '1rem',
                }}
              >
                <Trans t={t} i18nKey="home.pages" values={{ page, pagesAll }} />
              </div>

              <SlButtonGroup>
                <SlButton onClick={() => pageMinus()} disabled={page === 1}>
                  <SlIcon name="arrow-left-short"></SlIcon>
                </SlButton>
                <SlButton
                  onClick={() => pagePlus()}
                  disabled={page === pagesAll}
                >
                  <SlIcon name="arrow-right-short"></SlIcon>
                </SlButton>
              </SlButtonGroup>
            </div>
          )}
        </section>
      )}

      <section style={{ margin: '3rem 0 2rem' }}>
        <div style={{ color: baseTheme.neutrals['700'], textAlign: 'center' }}>
          {t('home.campaignBy')}
        </div>
        <a
          href={'https://www.protectourwinters.ch/'}
          target={'_blank'}
          rel="noreferrer"
        >
          <svg
            viewBox="0 0 533 174"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '50%', margin: '1rem auto', display: 'block' }}
          >
            <title>Protect Our Winters</title>
            <path
              d="M524.54 90.808a2.142 2.142 0 00-1.025-1.33l-15.42-8.293 13.544-5.31c.786-.435 1.081-1.448.668-2.25l-1.972-3.667a1.663 1.663 0 00-1.452-.87c-.274 0-.548.07-.787.201l-16.072 8.633-21.651-11.656 21.671-11.651 16.052 8.64c.239.13.513.192.787.192.612 0 1.165-.33 1.444-.88l1.98-3.658c.426-.813.134-1.796-.732-2.281l-13.462-5.275 15.378-8.273c.537-.316.9-.788 1.049-1.36a2.082 2.082 0 00-.204-1.667l-2.08-3.6a2.196 2.196 0 00-3.011-.812l-14.908 9.168 2.19-14.356a1.633 1.633 0 00-.443-1.194 1.677 1.677 0 00-1.159-.524l-4.205-.14c-.876 0-1.621.718-1.676 1.608l-.579 18.221-20.958 12.898.712-24.597 15.496-9.62a1.64 1.64 0 00.53-2.27l-2.189-3.55a1.686 1.686 0 00-1.412-.773c-.309 0-.608.09-.917.29l-11.31 9.027.514-17.472a2.218 2.218 0 00-2.206-2.233h-4.165c-1.219 0-2.193.99-2.193 2.21l.512 17.495-11.366-9.069a1.683 1.683 0 00-.865-.248 1.69 1.69 0 00-1.428.785l-2.18 3.531a1.678 1.678 0 00.527 2.292l15.505 9.599.707 24.609-20.968-12.908-.579-18.225c-.044-.882-.789-1.6-1.727-1.6l-4.144.14c-.91.021-1.628.796-1.606 1.784l2.184 14.289-14.875-9.157c-.352-.2-.74-.306-1.128-.306-.792 0-1.513.423-1.907 1.108l-2.074 3.6a2.203 2.203 0 00.812 3.012l15.425 8.288-13.556 5.314a1.67 1.67 0 00-.661 2.242l1.974 3.657c.279.55.842.88 1.47.88.262 0 .532-.06.781-.19l16.052-8.641 21.667 11.651-21.667 11.656L431.2 69.29a1.636 1.636 0 00-.797-.201 1.63 1.63 0 00-1.454.88l-1.974 3.658c-.427.814-.12 1.814.732 2.281l13.474 5.278-15.396 8.273a2.216 2.216 0 00-1.045 1.35 2.125 2.125 0 00.215 1.68l2.074 3.603a2.208 2.208 0 003.011.813l14.899-9.176-2.184 14.353a1.68 1.68 0 001.606 1.727l4.155.137h.04c.9 0 1.632-.706 1.672-1.613l.583-18.217 20.968-12.903-.707 24.614-15.485 9.602a1.641 1.641 0 00-.747 1.03c-.119.433-.035.881.2 1.248l2.189 3.537c.31.484.84.782 1.419.782.308 0 .612-.094.935-.282l11.281-9.033-.497 17.464c0 1.245.974 2.239 2.193 2.239h4.165c1.21 0 2.206-.994 2.206-2.206l-.514-17.501 11.356 9.071c.263.154.562.248.875.248.563 0 1.105-.293 1.408-.782l2.189-3.537c.23-.367.306-.815.21-1.248a1.731 1.731 0 00-.746-1.03l-15.49-9.614-.712-24.602 20.958 12.908.579 18.218a1.693 1.693 0 001.691 1.607h.03l4.16-.137c.924-.038 1.636-.804 1.596-1.787l-2.184-14.288 14.888 9.15a2.14 2.14 0 001.11.314c.797 0 1.533-.423 1.921-1.106l2.08-3.603c.293-.519.379-1.115.204-1.68zm7.917 35.989a2.29 2.29 0 01-2.289 2.284H419.112a2.299 2.299 0 01-2.293-2.284V5.743a2.296 2.296 0 012.293-2.287h111.056c1.26 0 2.289 1.02 2.289 2.287v121.054M194.005 66.242c0 18.043-12.697 33.41-31.824 33.41-18.926 0-31.966-15.726-31.966-33.769v-.356c0-18.046 12.685-33.414 31.622-33.414 19.112 0 32.168 15.723 32.168 33.77v.359zM71.079 49.265c0 9.828-7.511 16.262-19.837 16.262H34.803V32.47H51.06c12.508 0 20.019 5.722 20.019 16.44v.356zM368.729 3.35l-21.804 72.36L322.807 2.99h-29.822l-24.13 72.718-21.803-72.36h-36.621l9.486 28.58C208.46 13.272 187.511.847 162.181.847c-25.824 0-47.282 13.084-58.671 32.488C97.633 14.31 79.537 3.349 53.75 3.349H.152v125.076h34.651v-35.74h17.152c18.524 0 34.022-5.564 43.564-16.265 4.847 31.003 31.45 54.5 66.318 54.5 38.595 0 67.532-29.122 67.532-65.037v-.356c0-2.032-.114-4.032-.301-6.016l23.167 69.805h30.201l25.005-72.011 25.198 72.011h30.2L404.648 3.349h-35.919M10.36 150.51H4.942v9.548h5.418c3.523 0 5.721-1.931 5.721-4.773 0-3.145-2.235-4.775-5.721-4.775zm-.152 13.758H4.942v8.523H.28v-26.524h10.458c6.177 0 10.08 3.488 10.08 8.903 0 5.99-4.774 9.098-10.61 9.098M37.87 150.51h-6.784v8.906h6.822c3.334 0 5.456-1.743 5.456-4.472 0-2.919-2.047-4.434-5.494-4.434zm5.57 22.281l-6.518-9.246h-5.836v9.246h-4.661v-26.524h11.823c6.1 0 9.853 3.221 9.853 8.41 0 4.397-2.615 7.05-6.328 8.072l7.161 10.042H43.44M67.313 150.093c-5.27 0-8.944 4.207-8.944 9.398s3.75 9.473 9.019 9.473c5.266 0 8.942-4.204 8.942-9.397 0-5.19-3.752-9.474-9.017-9.474zm0 23.153c-8.149 0-13.833-6.176-13.833-13.679 0-7.502 5.76-13.754 13.908-13.754 8.146 0 13.83 6.176 13.83 13.678 0 7.504-5.76 13.755-13.906 13.755M97.475 172.791h-4.7v-22.203h-8.413v-4.321h21.524v4.321h-8.411v22.203zM131.312 150.436h-15.005v6.895h13.3v4.169h-13.3v7.122H131.5v4.169h-19.855v-26.524h19.667v4.169M150.183 173.246c-7.731 0-13.491-6.025-13.491-13.679 0-7.578 5.647-13.754 13.68-13.754 4.888 0 7.844 1.704 10.381 4.131l-2.993 3.447c-2.121-1.97-4.395-3.298-7.427-3.298-5.077 0-8.752 4.17-8.752 9.398 0 5.229 3.675 9.473 8.752 9.473 3.259 0 5.344-1.325 7.618-3.448l2.993 3.033c-2.767 2.879-5.797 4.697-10.761 4.697M177.881 172.791h-4.698v-22.203h-8.412v-4.321h21.522v4.321h-8.412v22.203M203.271 150.093c-5.268 0-8.944 4.207-8.944 9.398s3.752 9.473 9.018 9.473c5.267 0 8.942-4.204 8.942-9.397 0-5.19-3.75-9.474-9.016-9.474zm0 23.153c-8.15 0-13.832-6.176-13.832-13.679 0-7.502 5.76-13.754 13.906-13.754 8.148 0 13.831 6.176 13.831 13.678 0 7.504-5.76 13.755-13.905 13.755M245.937 161.312c0 7.919-4.473 11.897-11.408 11.897-6.896 0-11.29-3.978-11.29-11.672v-15.27h4.66v15.081c0 4.928 2.538 7.58 6.708 7.58 4.13 0 6.668-2.501 6.668-7.391v-15.27h4.662v15.045zM264.617 150.51h-6.782v8.906h6.82c3.334 0 5.456-1.743 5.456-4.472 0-2.919-2.048-4.434-5.494-4.434zm5.572 22.281l-6.52-9.246h-5.834v9.246h-4.663v-26.524h11.824c6.1 0 9.851 3.221 9.851 8.41 0 4.397-2.612 7.05-6.328 8.072l7.164 10.042h-5.494M296.672 146.192h3.94l6.52 19.743 6.329-19.668h4.887l-9.245 26.715h-4.016l-6.519-19.061-6.519 19.061h-4.016l-9.245-26.715h5.041l6.33 19.668 6.513-19.743M328.883 146.267v26.524h-4.663v-26.524h4.663zM355.331 146.267h4.586v26.524h-3.906l-14.623-18.87v18.87h-4.584v-26.524h4.319l14.208 18.341v-18.341M378.787 172.791h-4.698v-22.203h-8.414v-4.321h21.521v4.321h-8.409v22.203zM412.624 150.436h-15.003v6.895h13.296v4.169h-13.296v7.122h15.192v4.169h-19.854v-26.524h19.665v4.169M430.621 150.51h-6.781v8.906h6.823c3.333 0 5.452-1.743 5.452-4.472 0-2.919-2.044-4.434-5.494-4.434zm5.575 22.281l-6.52-9.246h-5.836v9.246h-4.657v-26.524H431c6.101 0 9.853 3.221 9.853 8.41 0 4.397-2.613 7.05-6.325 8.072l7.161 10.042h-5.493M457.637 157.408c5.614 1.364 8.53 3.371 8.53 7.805 0 5.003-3.907 7.957-9.475 7.957-4.056 0-7.883-1.401-11.067-4.242l2.807-3.335c2.537 2.196 5.075 3.448 8.375 3.448 2.88 0 4.696-1.325 4.696-3.374 0-1.93-1.059-2.955-5.986-4.092-5.648-1.363-8.828-3.03-8.828-7.958 0-4.621 3.788-7.728 9.058-7.728 3.865 0 6.93 1.173 9.624 3.334l-2.504 3.525c-2.383-1.783-4.771-2.731-7.2-2.731-2.727 0-4.32 1.404-4.32 3.183 0 2.085 1.214 2.996 6.29 4.208M471.66 172.791v-5.19h5.041v5.19h-5.041zM494.321 173.246c-7.728 0-13.49-6.025-13.49-13.679 0-7.578 5.648-13.754 13.678-13.754 4.887 0 7.843 1.704 10.38 4.131l-2.99 3.447c-2.124-1.97-4.394-3.298-7.43-3.298-5.076 0-8.752 4.17-8.752 9.398 0 5.229 3.676 9.473 8.752 9.473 3.26 0 5.346-1.325 7.619-3.448l2.996 3.033c-2.767 2.879-5.803 4.697-10.763 4.697M515.464 161.615v11.176h-4.663v-26.524h4.663v11.026h12.653v-11.026h4.663v26.524h-4.663v-11.176h-12.653"
              fill={baseTheme.neutrals['700']}
            ></path>
          </svg>
        </a>
      </section>
    </div>
  );
};

export default Home;
